// extracted by mini-css-extract-plugin
export default {"errorImageContainer":"ErrorPage_errorImageContainer__6VKR9"};